import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex justify-center items-center">
      <div 
        className="animate-spin rounded-full h-12 w-12 border-4 border-t-4 border-gray-300 border-t-gray-900"
      ></div>
    </div>
  );
};

export default LoadingSpinner;